<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="600px">
        <div class="row" v-loading="loading">
            <div class="col-12">
                <x-input v-model="form.name"
                         label="Nombre"></x-input>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose"></x-button-cancel>
                <x-button-submit @click="onSubmit"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XButtonCancel from "../../../../components/Form/XButtonCancel";
import XButtonSubmit from "../../../../components/Form/XButtonSubmit";
import XModal from "../../../../components/XModal";
import XInput from "../../../../components/Form/XInput.vue";
import XButtonIcon from "../../../../components/Form/XButtonIcon.vue";

export default {
    name: 'ShippingTypeForm',
    components: {XButtonIcon, XInput, XModal, XButtonSubmit, XButtonCancel},
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        recordId: {
            default: null
        }
    },
    data() {
        return {
            title: null,
            loading: false,
            resource: 'shipping_types',
            errors: {},
            form: {}
        }
    },
    created() {
        this.initForm();
    },
    methods: {
        initForm() {
            this.title = '';
            this.errors = {};
            this.form = {
                id: null,
                name: null,
            }
        },
        async handleOpen() {
            this.initForm();
            if (this.recordId) {
                this.loading = true;
                await this.$http.get(`/${this.resource}/record/${this.recordId}`)
                    .then(response => {
                        this.form = response.data.data
                    }).catch(error => {
                        console.log(error)
                    })
                this.loading = false;
                this.title = 'Editar tipo de envío'
            } else {
                this.title = 'Nuevo tipo de envío'
            }
        },
        async onSubmit() {
            this.loading = true;
            await this.$http.post(`/${this.resource}`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.clickClose()
                        this.$emit('success')
                    } else {
                        this.$message.error(response.data.message)
                    }
                }).catch(error => {
                    console.log(error)
                })
            this.loading = false
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        }
    }
}
</script>
